import { lazy } from 'react';

import AcessGeneral from '../../views/Settings/MembersSetup/AccessSchedule/AcessGeneral';
const CampaignGroupForm = lazy(() => import('../../views/Settings/MembersSetup/CampaignsGroup/CampaignGroupsForm'));
const CompaignsForm = lazy(() => import('../../views/Settings/MembersSetup/Campaigns/CompaignsForm'));
const ResourceTypeForm = lazy(() => import('../../views/Settings/MembersSetup/ResourceType/ResourceTypeForm'));
const ResourcesForm = lazy(() => import('../../views/Settings/MembersSetup/Resources/ResourcesForm'));
const MembershipTypeForm = lazy(() => import('../../views/Settings/MembersSetup/MembershipTypes/MembershipTypeForm'));
const MemberSettingsRoutes = [
    {
        path: '/membership-type/add',
        name: 'Add Membership Type',
        exact: true,
        component: MembershipTypeForm,
    },
    {
        path: '/membership-type/edit/:id',
        name: 'Members',
        exact: true,
        component: MembershipTypeForm,
    },
    {
        path: '/campaign-group/add',
        name: 'Add Campaign Group',
        exact: true,
        component: CampaignGroupForm,
    },
    {
        path: '/campaign-group/edit/:id',
        name: 'Campaign Group',
        exact: true,
        component: CampaignGroupForm,
    },
    {
        path: '/campaigns/add',
        name: 'Add Campaign',
        exact: true,
        component: CompaignsForm,
    },
    {
        path: '/campaigns/edit/:id',
        name: 'Campaign',
        exact: true,
        component: CompaignsForm,
    },
    {
        path: '/resource-type/add',
        name: 'Add Resource Type',
        exact: true,
        component: ResourceTypeForm,
    },
    {
        path: '/resource-type/edit/:id',
        name: 'Resource Type',
        exact: true,
        component: ResourceTypeForm,
    },
    {
        path: '/resources/add',
        name: 'Add Resource',
        exact: true,
        component: ResourcesForm,
    },
    {
        path: '/resources/edit/:id',
        name: 'Resource',
        exact: true,
        component: ResourcesForm,
    },
    {
        path: '/access-schedule/add',
        name: 'Add Access Schedule',
        exact: true,
        component: AcessGeneral,
    },
    {
        path: '/access-schedule/edit/:id',
        name: 'Access Schedule',
        exact: true,
        component: AcessGeneral,
    },
];
export default MemberSettingsRoutes;
